import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

class GrowExample extends React.Component {
  render() {
    return <Spinner animation="grow" variant="secondary"/>;
  }
}

export default GrowExample;